(function(){
  /* Carrousel d'avis */
  var viewport = document.getElementById('cm-rv-viewport');
  var track    = document.getElementById('cm-rv-track');
  var dotsWrap = document.getElementById('cm-rv-dots');
  if (track && viewport) {
    var cards   = Array.from(track.querySelectorAll('.cm-rv-card'));
    var total   = cards.length;
    var current = 0;
    var autoTimer;

    cards.forEach(function(_, i){
      var d = document.createElement('button');
      d.className = 'cm-rv-dot';
      d.setAttribute('aria-label', 'Avis ' + (i + 1));
      d.addEventListener('click', function(){ goTo(i); startAuto(); });
      dotsWrap.appendChild(d);
    });
    var dots = Array.from(dotsWrap.querySelectorAll('.cm-rv-dot'));

    function goTo(idx) {
      current = ((idx % total) + total) % total;
      var cardW = cards[0].offsetWidth;
      track.style.transform = 'translateX(' + (-current * cardW) + 'px)';
      dots.forEach(function(d, i){ d.classList.toggle('cm-rv-dot-active', i === current); });
    }

    function startAuto(){
      clearInterval(autoTimer);
      autoTimer = setInterval(function(){ goTo(current + 1); }, 4500);
    }

    document.getElementById('cm-rv-prev').addEventListener('click', function(){ goTo(current - 1); startAuto(); });
    document.getElementById('cm-rv-next').addEventListener('click', function(){ goTo(current + 1); startAuto(); });

    var startX = 0;
    viewport.addEventListener('touchstart', function(e){ startX = e.touches[0].clientX; }, {passive:true});
    viewport.addEventListener('touchend',   function(e){
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40){ goTo(dx < 0 ? current + 1 : current - 1); startAuto(); }
    });

    window.addEventListener('resize', function(){ goTo(current); });

    goTo(0);
    startAuto();
  }

  /* Zones cliquables du plan */
  document.querySelectorAll('.cm-lib-plan-zone').forEach(function(z){
    z.setAttribute('role', 'link');
    z.setAttribute('tabindex', '0');
    function go(){ var dest = z.getAttribute('data-href'); if (dest) { window.location.assign(dest); } }
    z.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); go(); });
    z.addEventListener('keydown', function(ev){
      if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); go(); }
    });
  });

  /* Google Maps : chargé seulement quand la carte approche de l'écran (gain de vitesse mobile) */
  var ifr = document.querySelector('iframe[data-src]');
  if (ifr) {
    var load = function(){ if (ifr.getAttribute('data-src')) { ifr.src = ifr.getAttribute('data-src'); ifr.removeAttribute('data-src'); } };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries){
        if (entries[0].isIntersecting) { load(); io.disconnect(); }
      }, { rootMargin: '0px 0px 150px 0px' });
      io.observe(ifr);
    } else { window.addEventListener('scroll', load, { once: true }); }
  }
})();
